<template>
  <div class="party">
    <!-- 宣传教育 -->
    <div class="bgimg1">
      <span ref="site0"></span>
      <div class="box1">
        <div class=" top-tit pb-0">
          宣传教育
          <div class="bbact"></div>
        </div>
        <div class="f-row-l align-start  w-100">
          <div class="navbox">
            <div class="nav act pinter" :class="ind==act?'actnav':''" v-for="(item,ind) in navs" :key='ind'
                 @click="onNav(ind)">
              {{ item.label }}
            </div>
          </div>
          <div class="wr f-row-b wrap">
            <div class="item act-h pinter w-50 f-row-l " v-for="(item,ind) in publicity" :key='ind'
                 @click.stop="$util.goPage('newDetail',14,item.id)">
              <div class="bord-t time">
                <div class="day">{{ $util.getTimeDay(item.createTime) }}</div>
                <div>{{ $util.getTimeYM(item.createTime) }}</div>
              </div>
              <div class="txt">{{ item.title ? item.title : '' }}</div>
            </div>
          </div>

        </div>

      </div>
      <div class="color-red more1 f-row-c posit-b1 pinter" @click.stop="$util.goPage('news',14)">
        查看更多<img src='../../assets/img/party/more1.png'/>
      </div>
    </div>
    <!-- 专题活动 -->
    <div class="bg-none">
      <span ref="site1"></span>
      <div class="box1">
        <div class=" top-tit ">
          专题活动
          <div class="bbact"></div>
        </div>
        <div class="f-row-c align-start  w-100">
          <ul class="wr1 bg-red color-white min-4">
            <el-image fit='cover' :src="$fileAccessHttpUrl(activityImg)" class="img1"></el-image>
            <div class="box-r font-1">
              <div class="font-0 mb-2 mt-6 act_tit">{{ activity.title }}</div>
              <li v-for="(item,ind) in activity.activityItems" :key='ind' class="pinter"
                  @click.stop="$util.goPage('newDetail',15,item.id)">
                {{ item.title ? item.title : '' }}
              </li>
            </div>
            <div class="posit-b more1 f-row-c pinter" @click.stop="$util.goPage('Events',15)">
              查看更多<img src='../../assets/img/party/more2.png'/>
            </div>
          </ul>

        </div>

      </div>
    </div>
    <!-- 党风廉政 -->
    <div class="bgimg2">
      <span ref="site2"></span>
      <div class="box1 color-white">
        <div class=" top-tit color-white pb-0">
          党风廉政
          <div class="bbact-w"></div>
        </div>
        <div class="f-row-c align-start  w-100">
          <div class="wr f-row-b wrap">
            <div class="item pinter w-50 f-row-l" v-for="(item,ind) in PartysWorkStyle" :key='ind'
                 @click.stop="$util.goPage('newDetail',16,item.id)">
              <div class="time bord-t bord-t-w">
                <div class="day">{{ $util.getTimeDay(item.createTime) }}</div>
                <div>{{ $util.getTimeYM(item.createTime) }}</div>
              </div>
              <div class="txt">{{ item.title ? item.title : '' }}</div>
            </div>
          </div>
        </div>

      </div>
      <div class="color-white more1 f-row-c posit-b1 pinter" @click.stop="$util.goPage('news',16)">
        查看更多<img src='../../assets/img/party/more2.png'/>
      </div>
    </div>
    <!-- 试听课件 -->
    <div class="bgimg4">
      <span ref="site3"></span>
      <div class="box1">
        <div class=" top-tit pb-0">
          试听课件
          <div class="bbact"></div>
        </div>
        <div class="f-row-c align-start  w-100">
          <div class="wr f-row-b">
            <div class="w-50" v-if='listeningTest.length>1'>
              <div class="item mb-0 pinter w-100 f-row-start-l color-black" :style="{paddingBottom:ind==1?'43px':''}"
                   v-if='ind!=0' v-for="(item,ind) in listeningTest" :key='ind'
                   @click.stop="$util.goPage('newDetail',32,item.id)">
                <div class="videobox_small overf-h f-row-c" @click.stop>
                  <videoBox :itemPlayTip='item.playTip' :file='item.file?item.file.split(",")[0]:""' :index='ind' @onChangeVideo='onChangeVideo'></videoBox>
                </div>
                <div class="videobox_txt act-h">
                  <div class="bb-1 overf-elli w-100 pb-1">{{ item.title ? item.title : '' }}</div>
                  <div class="time1 font-1 mt-1 f-row-r">
                    {{ item.createTime ? item.createTime.split(' ')[0] : '' }}
                  </div>
                </div>
              </div>
            </div>
            <div class="w-50" v-if='listeningTest.length>0'
                 @click.stop="$util.goPage('newDetail',32,listeningTest[0].id)">
              <div @click.stop class="videobox_big overf-h f-row-c pinter">
                <videoBox :itemPlayTip='listeningTest[0].playTip' :file='listeningTest[0].file?listeningTest[0].file.split(",")[0]:""' :index='0' @onChangeVideo='onChangeVideo'></videoBox>
              </div>

            </div>

          </div>
        </div>

      </div>
      <div class="color-red more1 f-row-c posit-b1 pinter" @click.stop="$util.goPage('listeningTestList',31)">
        查看更多<img src='../../assets/img/party/more1.png'/>
      </div>
    </div>
    <!--  党务知识 -->
    <div class="bgimg3">
      <span ref="site4"></span>
      <div class="box1">
        <div class="top-tit pb-0">
          党务知识
          <div class="bbact"></div>
        </div>
        <div class="f-row-c align-start  w-100">
          <div class="wr f-row-b wrap">
            <div class="item act-h pinter f-row-l w-50" v-for="(item,ind) in Knowledge" :key='ind'
                 @click.stop="$util.goPage('newDetail',17,item.id)">
              <div class="time bord-t bord-t">
                <div class="day">{{ $util.getTimeDay(item.createTime) }}</div>
                <div>{{ $util.getTimeYM(item.createTime) }}</div>
              </div>
              <div class="txt">
                {{ item.title ? item.title : '' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more1 f-row-c posit-b1 pinter" @click.stop="$util.goPage('news',17)">
        查看更多<img src='../../assets/img/party/more1.png'/>
      </div>
    </div>
    <!-- 规章制度 -->
    <div class="bg-none">
      <span ref="site5"></span>
      <div class="box1">
        <div class=" top-tit ">
          规章制度
          <div class="bbact"></div>
        </div>
        <div class="f-row-c align-start w-100">
          <img src="../../assets/img/party/img2.png" class="w-50"/>
          <div class="w-50">
            <div class="f-row-b wrap mb-2 pb-1 act-h pinter" v-for="(item,ind) in system" :key='ind'
                 @click.stop="$util.goPage('newDetail',18,item.id)">
              <div class="font-1 pl-4 w-80 ">{{ item.title ? item.title : '' }}</div>
              <div class="time1 font-1 pl-1">
                {{ item.createTime ? item.createTime.split(' ')[0] : '' }}
              </div>

            </div>
          </div>
        </div>
        <div class="more1 f-row-c mt-3 mb-8 pinter" @click.stop="$util.goPage('news',18)">
          查看更多<img src='../../assets/img/party/more1.png'/>
        </div>
      </div>
    </div>
    <!--  学习书库 -->
    <div class="bgimg5">
      <span ref="site6"></span>
      <div class="box1">
        <div class="top-tit pb-0">
          学习书库
          <div class="bbact"></div>
        </div>
        <div class="f-row-c align-start  w-100">
          <div class="wr f-row-start-l wrap">
            <!-- $util.goPage('newDetail',19,item.id) -->
            <div class="itembox act-h pinter f-row-start-l" v-for="(item,ind) in study" :key='ind'
                 @click.stop="goDetail(item)">
              <el-image class="item-l" fit='cover' :src='$fileAccessHttpUrl(item.bookCover)'></el-image>
              <div class="item-r">
                <div class="line2">{{ item.bookName||''}}</div>
                <div class="name">作 (编) 者：{{ item.author|| '' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more1 f-row-c posit-b1 pinter" @click.stop="$util.goPage('studyList',19)">
        查看更多<img src='../../assets/img/party/more1.png'/>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
      act: 0,
      navs: [
        {label: '宣传教育'},
        {label: '专题活动'},
        {label: '党风廉政'},
        {label: '试听课件'},
        {label: '党务知识'},
        {label: '规章制度'},
        {label: '学习书库'},
      ],
      activityImg: '',
      publicity: [],//宣传教育
      activity: [],//专题活动
      PartysWorkStyle: [],//党风廉政
      listeningTest: [],//试听课件
      Knowledge: [],//党务知识
      system: [],//规章制度
      study: [],//学习书库
    };
  },

  created() {
    this.init()
  },

  methods: {
    goDetail(item){window.open(item.linkHref)},
    onChangeVideo(e){
      for(var i=0;i<this.listeningTest.length;i++){ 
        if(i==e.index){ 
          this.$set(this.listeningTest[e.index],'playTip',e.playTip)
        }else{ 
          this.$set(this.listeningTest[e.index],'playTip',!e.playTip)
        }
      }
      
    },
    init() {
      this.getPublicity();
      this.getActivity();
      this.getPartysWorkStyle();
      this.getKnowledge();
      this.getSystem();
      this.getStudy();

      this.getListeningTest()
    },
    getListeningTest() {//试听课件
      // this.listeningTest = [];
      var param = {
        pageNo: 1,//分页
        pageSize: 3,
        msgType: 39
      }
      this.$get('/web/information/list', param).then(res => {
        this.listeningTest = res.result.records;
      })
    },
    getPublicity() {//宣传教育
      var param = {
        pageNo: 1,//分页
        pageSize: 6,
        msgType: 8
      }
      this.$get('/web/information/list', param).then(res => {
        this.publicity = res.result.records;
      })
    },
    getActivity() {//专题活动
      var param = {
        pageNo: 1,//分页
        pageSize: 1,
      }
      this.$get('web/home/newActList', param).then(res => {
        // this.activity = res.result.records[0];
        this.activity = res.result.records[0];
        this.activityImg = res.result.records[0].rawMap
      })
    },
    getPartysWorkStyle() {//党风廉政
      var param = {
        pageNo: 1,//分页
        pageSize: 6,
        msgType: 9
      }
      this.$get('/web/information/list', param).then(res => {
        this.PartysWorkStyle = res.result.records;
      })
    },
    getKnowledge() {//党务知识
      var param = {
        pageNo: 1,//分页
        pageSize: 6,
        msgType: 10
      }
      this.$get('/web/information/list', param).then(res => {
        this.Knowledge = res.result.records;
      })
    },
    getSystem() {//规章制度
      var param = {
        pageNo: 1,//分页
        pageSize: 8,
        msgType: 11
      }
      this.$get('/web/information/list', param).then(res => {
        this.system = res.result.records;
      })
    },
    // getStudy() {//学习书库
    //   var param = {
    //     pageNo: 1,//分页
    //     pageSize: 6,
    //     msgType: 12
    //   }
    //   this.$get('/web/information/list', param).then(res => {
    //     this.study = res.result.records;
    //   })
    // },
    getStudy() {//学习书库
      this.bookes = []
      var param={
        pageNo: 1,//分页
        pageSize:6,
        bookCatalogue:0
      };
      this.$get('/web/studyLibrary/list', param).then(res => {
        this.study = res.result.records;
      })
    },
    onscroll(val) {
      var returnEle = this.$refs[val];
      if (!!returnEle) {
        returnEle.scrollIntoView(true);
      }
    },
    onNav(ind) {
      this.act = ind
      this.onscroll('site' + ind)
    }
  },
};
</script>

<style lang="scss" scoped>
.bord-t {
  position: relative;
}
.act_tit{ 
  width: calc(100% + 20px);
  transform: translateX(-20px);
}
.bord-t::before {
  content: '';
  position: absolute;
  width: 42px;
  height: 3px;
  background: #A62725;
  z-index: 2;
  left: calc(50% - 21px);
  top: 0px;
}

.bord-t-w::before {
  background: #ffffff;
}

.party {
  // background: #ffffff;

  .top-tit {
    text-align: center;
    padding: 83px 0px 64px;
    max-width: 1200px;
    font-size: 30px;
    position: relative;
    margin: auto;

    .bbact, .bbact-w {
      width: 0px;
      transition: width .5s;

      &::after {
        height: 2px;
      }
    }
  }

  .pb-0 {
    padding-bottom: 0px;
  }

  .ml {
    margin-left: 184px;
    max-width: 1100px;
  }

  .top-tit:hover {
    color: #BA0711;

    .bbact, .bbact-w {
      width: 100%;

    }
  }

  .bgimg2 {
    .top-tit:hover {
      color: #ffffff;
    }
  }

  .box1 {
    // width: 1284px;
    width: 1200px;
    padding: 10px;
    position: relative;
    margin: auto;

    .wr {
      height: 100%;
      margin-left: 40px;
      width: 1100px;
      margin-top: 82px;
      position: relative;

      .item {
        // width: 50%;
        margin-bottom: 10px;
        // display: inline-block;
        font-size: 16px;

        .time {
          width: 80px;
          padding: 30px 0px;
          text-align: center;
          // display: inline-block;
          .day {
            font-size: 30px;
          }

        }

        .txt {
          padding: 30px 0px;
          padding-left: 20px;
          box-sizing: border-box;
          // display: inline-block;
          width: calc(100% - 80px);
        }

      }
      .mb-0{
        margin-bottom: 0px;
      }

    }

    .wr1 {
      width: 1010px;
      margin-top: 60px;
      margin-left: 132px;

      .box-r {
        margin-left: calc(64.45% - 100px);
        margin-right: 10px;
        position: relative;

        li {
          padding: 10px 0px;
        }
      }

      .img1 {
        width: 64.45%;
        height: 433px;
        position: absolute;
        left: -132px;
        top: -59px;
      }
    }

    .min-4 {
      min-height: 425px;
      position: relative;
    }
  }

}

.more1 {
  font-size: 16px;

  img {
    width: 34px;
    margin-left: 60px;
  }
}

.mb-8 {
  margin-bottom: 87px;
}

.posit-b, .posit-b1 {
  position: absolute;
  bottom: 37px;
  left: calc(50% + 50px);
}

.posit-b1 {
  left: calc(50% - 79px);
}

.bg-red {
  background: #A62725;
}

.navbox {
  width: 144px;
  position: relative;
  z-index: 2;

  .nav {
    padding: 14px 0px;
    text-align: center;
    background: transparent;
  }

  .actnav {
    background: #A62725;
    color: #ffffff;
  }

  .actnav1 {
    background: #ffffff;
    color: #333333;
  }
}

.bg-none {
  position: relative;
}

.bgimg1 {
  height: 784px;
  background: url('../../assets/img/party/bg1-1.png') no-repeat center top;
  background-size: auto 100%;
  background-size: 100% auto;
  position: relative;
}

.bgimg3 {
  height: 784px;
  background: url('../../assets/img/party/bg3.png') no-repeat center top;
  background-size: auto 100%;
  background-size: 100% auto;
  position: relative;
}

.bgimg2 {
  height: 812px;
  background: url('../../assets/img/party/bg2.png') no-repeat center top;
  background-size: auto 100%;
  background-size: 100% auto;
  position: relative;
}

.bgimg4 {
  height: 784px;
  background-size: auto 100%;
  background-size: 100% auto;
  position: relative;

  .videobox_small,
  .videobox_big {
    background: #000000;
    width: 563px;
    height: 370px;
    position: relative;
  }

  .videobox_small {
    width: 176px;
    height: 114px;
  }

  .videobox_txt {
    width: calc(100% - 176px);
    padding-left: 18px;
    padding-right: 38px;
  }
}
.bgimg5{ 
  min-height: 784px;
  padding-bottom: 80px;
  position: relative;
  .box1 .wr {
    // [data-v-3d741681]
    height: 100%;
    margin-left: 0px;
    width: 100%;
    margin-top: 82px;
    position: relative;
  }
  .itembox {
      width:calc(33.33% - 20px);
      margin-left: 30px;
      list-style: none;
      text-align: left;
      line-height: 25px;
      margin-bottom: 65px;
      // font-size: 18px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      position: relative;
      .item-l{
        width: 139px;
        height: 174px;
        box-shadow: 0px 4px 12px 0px #AFAFAF;
      }
      .item-r{
        width: calc(100% - 155px);
        margin-left: 20px;
        line-height: 34px;
        padding-top: 10px;
        font-weight: normal;
      }
      .name {
        color: #666666;
        padding-top: 30px;
      }
    }
    .itembox:nth-child(3n+1){
      margin-left: 0px;
    }
}
</style>
